import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-page px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-clapperboard-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">妈妈的职业电影</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              专注《妈妈的职业电影》的剧情解析、演员档案与观影指南。用清晰的内容帮你读懂一部关于母亲、也关于我们每一个人的电影。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">
              <a href="/#content-sections" className="cursor-pointer">内容导航</a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-700">
              <li><Link to="/category/film-info" className="cursor-pointer hover:text-primary-700">电影资讯</Link></li>
              <li><Link to="/category/related-info" className="cursor-pointer hover:text-primary-700">相关影视资讯</Link></li>
              <li><Link to="/guide" className="cursor-pointer hover:text-primary-700">观影指南</Link></li>
              <li><Link to="/about" className="cursor-pointer hover:text-primary-700">关于本站</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">
              <a href="/#content-sections" className="cursor-pointer">热门推荐</a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-700">
              <li><Link to="/detail/art-01" className="cursor-pointer hover:text-primary-700">剧情全解析</Link></li>
              <li><Link to="/detail/art-03" className="cursor-pointer hover:text-primary-700">结局解读</Link></li>
              <li><Link to="/detail/art-04" className="cursor-pointer hover:text-primary-700">人物关系图谱</Link></li>
              <li><Link to="/detail/art-13" className="cursor-pointer hover:text-primary-700">同类影片推荐</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 妈妈的职业电影 · 本站内容均为示范文本，仅供演示使用。</p>
          <p>剧情与演员信息均为虚构，不指向任何真实人物或作品。</p>
        </div>
      </div>
    </footer>
  );
}